import type { AnchoredContentSectionProps } from '@/components/anchored-content/AnchoredContent'

/**
 * --------------------------------------------------------------------------
 * AnchoredContentBlocks
 *
 * Wraps content blocks with an anchor ID and includes a div for the anchor
 *
 * @param {Object} sections - List of sections to render
 * @param {Object} sectionRefs - Ref to store section references
 * --------------------------------------------------------------------------
 **/
export default function AnchoredContentBlocks({
  sections,
  sectionRefs,
}: {
  sections: AnchoredContentSectionProps[]
  sectionRefs: React.RefObject<HTMLDivElement[]>
}) {
  return (
    <div className="flex w-[min(var(--container-s-max-w),100%)] flex-shrink-[2] flex-col gap-m @container/main">
      <div className="@container/nested-flex">
        {sections.map((section, index) => {
          const { anchorId, content } = section

          return (
            <div
              data-anchor-id={anchorId}
              key={`component-${index}`}
              ref={(el) => {
                sectionRefs.current[index] = el
              }}>
              <div id={section.anchorId} className="anchor"></div>

              {content}
            </div>
          )
        })}
      </div>
    </div>
  )
}
